export const PatientPersonalCareQuestions = [
  {
    name: "HAIR",
    tag: "hair",
    questions: [
      "a. Is the resident's hair clean and well groomed?",
      "b. Is the resident's hair styled appropriately?",
    ],
  },
  {
    name: "FACE",
    tag: "face",
    questions: [
      "a. Is the resident's face shaved?",
      "b. Are there any signs of skin irritation or redness on the resident's face?",
      "c. Are the resident's eyes free of drainage?",
      "d. Is there excess wax buildup in the resident's ears? *Please refer to NP for removal, if necessary*",
    ],
  },
  {
    name: "FINGER NAILS",
    tag: "fingerNails",
    questions: [
      "a. Are the resident's finger nails clean and trimmed?",
      "b. Are there any signs of nail infection or abnormalities?",
    ],
  },
  {
    name: "CLOTHING",
    tag: "clothing",
    questions: [
      "a. Is the resident's wearing clean clothes?",
      "b. Are the resident's clothes appropriate for the weather and their comfort?",
      "c. Is the resident's footwear in good condition and appropriate for use?",
    ],
  },
  {
    name: "ORAL CARE",
    tag: "oralCare",
    questions: [
      "a. Has the resident's teeth been brushed?",
      "b. Are there any signs of oral health issues or discomfort?",
    ],
  },
  {
    name: "CONTINENCE CARE",
    tag: "continenceCare",
    questions: [
      "a. Are assigned continence products (e.g. pads, briefs) provided and used correctly?",
      "b. Are continence care supplies stored and managed properly?",
    ],
  },
  {
    name: "PERSONAL ITEMS",
    tag: "personalItems",
    questions: [
      "a. Appropriate and clean personal items/personal aids (glasses, hearing aids, dentures)?",
      "b. Are personal items labelled?",
    ],
  },
  {
    name: "OVERALL APPEARANCE",
    tag: "overallAppearance",
    questions: [
      "a. Does the resident have an overall clean and well groomed appearance?",
      "b. Are there any signs of poor personal hygiene?",
    ],
  },
];

export const PatientEnvironmentQuestions = [
  {
    name: "BEDDING",
    tag: "bedding",
    questions: [
      "a. Is the resident's bedding clean and comfortable?",
      "b. Does the resident has a therapeutic sleep surface?",
      "c. Is the therapeutic sleep surface functioning?",
      "d. Is the bed against the wall?",
      "e. Can the resident exit the bed independently?",
    ],
  },
  {
    name: "TOWELS",
    tag: "towels",
    questions: [
      "a. Is there a set of towels left in the washroom for resident? \nNote (please ensure only 1 set is left in room, remove any extra)",
    ],
  },
];

export const PatientMobilityAidsQuestions = [
  {
    name: "MOBILITY AIDS",
    tag: "mobilityAids",
    questions: [
      "a. Is the resident's wheelchair or walker clean and in working order?",
      "b. Are there any signs of damage or malfunctioning?",
      "c. Mobility aids labeled (walkers/wheelchairs)?",
      "d. Appropriate restraints/PASD/tilt applied according to care plan?",
    ],
  },
];

export const PatientPCCQuestions = [
  {
    name: "POINT CLICK CARE",
    tag: "pcc",
    questions: ["a. Completed monthly pain audit on PointClickCare?"],
  },
];
